// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Promise, STREAM, Weaver, WeaverError, WeaverFile, WeaverObject, cuid, getFs, path, ss;

  path = require('path');

  Promise = require('bluebird');

  ss = require('socket.io-stream');

  cuid = require('cuid');

  WeaverError = require('./Error');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  STREAM = Weaver.STREAM;

  getFs = function() {
    return require('fs');
  };

  WeaverFile = class WeaverFile extends WeaverObject {
    constructor(filePath, id) {
      super(id, filePath != null ? filePath.name : void 0);
      this.filePath = filePath;
      this._local = false;
      this._stored = false;
      if ((typeof File !== "undefined" && File !== null) && this.filePath instanceof File) {
        this.fileSize = this.filePath.size;
        this.fileName = this.filePath.name;
        this.fileExt = path.extname(this.filePath.name);
        this._local = true;
      } else {
        if ((this.filePath != null) && this._fileExists(this.filePath)) {
          this._getFileStats(this.filePath);
        }
      }
      this._listeners = {};
    }

    /**
     * Retreive filepath
     * @returns {String} The filepath
     */
    path() {
      return this.filePath;
    }

    /**
     * Gets the extension
     * @return {String} The extension of the file
     */
    extension() {
      return this.fileExt;
    }

    /**
     * Gets the filesize
     * @return {Integer} The filesize in bytes
     */
    size() {
      return this.fileSize;
    }

    /**
     * Set the path for the file. This does not directly check
     * whether the file exists
     * @param {String} filepath The path for the file
     * @returns {WeaverFile} The current WeaverFile instance
     */
    setPath(filePath) {
      if (this._fileExists(filePath)) {
        this._getFileStats(filePath);
        this.filePath = filePath;
      } else {
        this._local = false;
      }
      return this;
    }

    /**
     * Set the name for the file. You do not have to specify the filename
     * through this function when supplying a filepath.
     * @param {String} fileName The string to set as the name
     * @returns {WeaverFile} The current WeaverFile instance
     */
    setName(fileName) {
      this._name = fileName;
      this.fileName = fileName;
      return this;
    }

    /**
     * Set the extension of the file.
     *
     */
    setExtension(extension) {
      this.fileExt = extension;
      return this;
    }

    /**
     * Private function to check if the file exists on the disk.
     * whether the file exists
     * @param {String} filePath The path to check
     * @returns {fs.Stats}
     */
    _fileExists(filePath) {
      return getFs().existsSync(filePath);
    }

    _getFileStats(filePath) {
      var _stats, err;
      try {
        _stats = getFs().statSync(filePath);
        this.setName(path.basename(filePath));
        this.setExtension(path.extname(filePath));
        this.fileSize = _stats.size;
        return this._local = true;
      } catch (error) {
        err = error;
        throw WeaverError(Weaver.Error.FILE_NOT_EXISTS_ERROR);
      }
    }

    /**
     * List all files in the object storage
     * @returns {Promise<Array<WeaverFile>>} Promise that resolves with
     * an array of WeaverFile instances
     */
    static async list() {
      var fileObject, i, len, results, storedFiles;
      storedFiles = (await GET("file.list"));
      results = [];
      for (i = 0, len = storedFiles.length; i < len; i++) {
        fileObject = storedFiles[i];
        results.push(WeaverFile.loadFromServerObject(fileObject));
      }
      return results;
    }

    static async load(fileId) {
      var e, fileObject;
      try {
        fileObject = (await GET("file.read", {
          fileId: fileId
        }));
      } catch (error) {
        e = error;
        throw new Error(`File with id ${fileId} not found`);
      }
      return WeaverFile.loadFromServerObject(fileObject);
    }

    static loadFromServerObject(fileObject) {
      var fileExt, fileName, id, storedFile;
      fileName = fileObject.name.substring(fileObject.name.indexOf('-') + 1);
      id = fileObject.name.slice(0, fileObject.name.indexOf('-'));
      fileExt = path.extname(fileObject.name);
      storedFile = new WeaverFile(null, id);
      storedFile.setName(fileName);
      storedFile.setExtension(fileExt);
      storedFile.fileSize = fileObject.size;
      storedFile._stored = true;
      return storedFile;
    }

    /**
     * Uploads the instance of WeaverFile to the object storage
     * @returns {Promise<WeaverFile>} The stored WeaverFile
     */
    async upload() {
      var _uploadedBytes, readStream, stream;
      if (((typeof File !== "undefined" && File !== null) && this.filePath instanceof File) || this._fileExists(this.filePath)) {
        stream = ss.createStream();
        readStream = (typeof File !== "undefined" && File !== null) && this.filePath instanceof File ? ss.createBlobReadStream(this.filePath) : getFs().createReadStream(this.filePath);
        _uploadedBytes = 0;
        readStream.on('data', (chunk) => {
          var percentage;
          _uploadedBytes += chunk.length;
          percentage = Math.ceil((_uploadedBytes / this.fileSize) * 100);
          return this.emit('uploadProgress', percentage);
        });
        readStream.pipe(stream);
        if (this._id == null) {
          this._id = cuid();
        }
        await STREAM("file.upload", {
          fileId: this.id(),
          file: stream,
          filename: this.fileName
        });
        this._stored = true;
        return this;
      } else {
        throw WeaverError(Weaver.Error.FILE_NOT_EXISTS_ERROR, "File does not exist!");
      }
    }

    /**
     * Downloads a WeaverFile instance from the object storage
     * @param {String} filePath The path so save the file to.
     * @param {Boolean} deleteOnFinish If set to true the file will be deleted from storage as soon as the download is finised.
     * @returns {Promise<WeaverFile>} The instance of the downloaded WeaverFile
     */
    async download(filePath, deleteOnFinish = false) {
      var _downloadedBytes, stream, writeStream;
      this.filePath = path.resolve(filePath);
      stream = (await STREAM("file.download", {
        fileId: this.id(),
        deleteOnFinish
      }));
      _downloadedBytes = 0;
      writeStream = getFs().createWriteStream(this.filePath);
      stream.on('data', (chunk) => {
        var percentage;
        _downloadedBytes += chunk.length;
        percentage = this.fileSize != null ? Math.ceil((_downloadedBytes / this.fileSize) * 100) : 'unknown';
        return this.emit('downloadProgress', percentage);
      });
      stream.pipe(writeStream);
      return new Promise((resolve, reject) => {
        return writeStream.on('finish', () => {
          this._stored = true;
          this._local = true;
          return resolve(this);
        });
      });
    }

    /**
     * Returns a WeaverFile instance with only the ID set
     * Download progress won't work this way
     * @param {String} id The WeaverFile ID
     * @returns {WeaverFile} A new WeaverFile instance
     */
    static get(id) {
      return new WeaverFile(void 0, id);
    }

    /**
     * Remove a file from the object storage
     * This method will never delete anything from the local disk
     * @returns {Promise}
     */
    destroy() {
      return POST("file.delete", {
        fileId: this.id()
      });
    }

    startStream(filename) {
      var stream;
      this.setName(path.basename(filename));
      this.setExtension(path.extname(filename));
      if (this._id == null) {
        this._id = cuid();
      }
      stream = ss.createStream();
      this._uploadProcess = STREAM("file.upload", {
        fileId: this.id(),
        file: stream,
        filename
      });
      return stream;
    }

    async finishStream() {
      await this._uploadProcess;
      this._stored = true;
      return this;
    }

    emit(key, value) {
      var callback, i, len, ref, results;
      ref = this._listeners[key] || [];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        callback = ref[i];
        results.push(callback(value));
      }
      return results;
    }

    on(key, callback) {
      var base;
      if ((base = this._listeners)[key] == null) {
        base[key] = [];
      }
      return this._listeners[key].push(callback);
    }

    off(key, callback) {
      if (callback == null) {
        return delete this._listeners[key];
      } else {
        return this._listeners[key].splice(this._listeners[key].indexOf(callback), 1);
      }
    }

  };

  module.exports = WeaverFile;

}).call(this);
